import { render } from "./DNotify.vue?vue&type=template&id=51ecd2f7&scoped=true"
import script from "./DNotify.vue?vue&type=script&lang=js"
export * from "./DNotify.vue?vue&type=script&lang=js"

import "./DNotify.vue?vue&type=style&index=0&id=51ecd2f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ecd2f7"]])

export default __exports__